import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import { ProfilePicture } from './ProfilePicture';
import AppText from './AppText';
import { combineNames } from '../../services/utils';
import { globalStyle } from '../../styles/globalStyle';
import { AspNetUsers } from '../../entities/AspNetUsers';
import { t } from '../../services/translations';
import { MActu } from '../../entities/MActu';
import { User } from '../../entities/User';

export type UserSubRowProps = {
  user: {
    fichierIdProfil: number;
    nom: string;
    prenom: string;
    deletedAt?: string;
    aspNetUsers?: AspNetUsers;
    mActu?: MActu;
    userIdCreateurNavigation?: User;
  };
  withPicture?: boolean;
  style?: ViewStyle;
  textColor?: string;
  textSize?: number;
};

export function UserSubRow({ user, withPicture, style, textColor, textSize }: UserSubRowProps) {
  if (!user) {
    return <></>;
  }

  if (
    user.deletedAt ||
    user.aspNetUsers?.deletedAt ||
    user.mActu?.userIdCreateurNavigation?.aspNetUsers?.deletedAt ||
    user.userIdCreateurNavigation?.aspNetUsers?.deletedAt
  ) {
    return (
      <View style={[styles.container, style]}>
        <View style={styles.textContainer}>
          <AppText
            numberOfLines={1}
            style={{
              color: textColor || 'black',
              fontSize: textSize || globalStyle.appText.fontSize,
            }}
          >
            {t('inactive_user')}
          </AppText>
        </View>
      </View>
    );
  }

  return (
    <View style={[styles.container, style]}>
      {withPicture ? <ProfilePicture pictureId={user.fichierIdProfil} size="small" /> : null}
      <View style={styles.textContainer}>
        <AppText
          numberOfLines={1}
          style={{
            color: textColor || 'black',
            fontSize: textSize || globalStyle.appText.fontSize,
          }}
        >
          {combineNames(user)}
        </AppText>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textContainer: {
    marginLeft: 10,
    flex: 1,
  },
});
